import { push } from 'redux-first-router';
import { useQueryClient } from '@tanstack/react-query';

import { useMount } from '@simplywallst/ui-core';

import { getPath } from '@/router/utils';

import {
  ROUTE_PORTFOLIO_NEW,
  ROUTE_PORTFOLIO_DEFAULT,
} from '@/constants/routes';

import { PORTFOLIOS_QUERY_KEY } from '@/hooks/portfolio/usePortfolio';
import { useInitializeProviderConnection } from '../../components/PortfolioLinking';

import { useReduxStateForPortfolioLinkingSuccess } from './hooks/useReduxStateForPortfolioLinkingSuccess';

function goTo(type: string) {
  push(getPath({ type, payload: {} }));
}

export const PortfolioLinkingSuccess = () => {
  const queryClient = useQueryClient();
  const { provider, code } = useReduxStateForPortfolioLinkingSuccess();

  const { mutate } = useInitializeProviderConnection({
    onError() {
      goTo(ROUTE_PORTFOLIO_NEW);
    },
    onSuccess() {
      goTo(ROUTE_PORTFOLIO_DEFAULT);
      queryClient.invalidateQueries({
        queryKey: [PORTFOLIOS_QUERY_KEY],
      });
    },
  });

  useMount(() => {
    if (typeof provider === 'undefined' || typeof code === 'undefined') {
      console.error(
        `Could not save portfolio provider token, given provider: ${provider}, code: ${code}`
      );
      goTo(ROUTE_PORTFOLIO_NEW);
    } else {
      mutate({ provider, code });
    }
  });

  return null;
};
